import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

interface CautionIconProps {
  size?: number
  color?: string
}

const CautionIcon = ({
  size = 81,
  color = '#fff',
  ...props
}: CautionIconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 81 81"
    fill="none"
    {...props}
  >
    <Path
      d="M0 40.5C0 18.1325 18.1325 0 40.5 0C62.8675 0 81 18.1325 81 40.5C81 62.8675 62.8675 81 40.5 81C18.1325 81 0 62.8675 0 40.5Z"
      fill="#F06D0F"
    />
    <G clipPath="url(#clip0_275_2655)">
      <Path
        d="M40.5 46.5415C40.8205 46.5415 41.1278 46.4142 41.3544 46.1876C41.581 45.961 41.7083 45.6536 41.7083 45.3332V29.6248C41.7083 29.3044 41.581 28.997 41.3544 28.7704C41.1278 28.5438 40.8205 28.4165 40.5 28.4165C40.1795 28.4165 39.8722 28.5438 39.6456 28.7704C39.419 28.997 39.2917 29.3044 39.2917 29.6248V45.3332C39.2917 45.6536 39.419 45.961 39.6456 46.1876C39.8722 46.4142 40.1795 46.5415 40.5 46.5415ZM40.5 48.9582C40.1415 48.9582 39.7911 49.0645 39.493 49.2636C39.195 49.4628 38.9627 49.7459 38.8255 50.0771C38.6883 50.4082 38.6524 50.7727 38.7223 51.1243C38.7923 51.4759 38.9649 51.7988 39.2184 52.0523C39.4719 52.3058 39.7948 52.4784 40.1464 52.5483C40.498 52.6183 40.8624 52.5824 41.1936 52.4452C41.5248 52.308 41.8079 52.0757 42.007 51.7776C42.2062 51.4796 42.3125 51.1291 42.3125 50.7707C42.3125 50.29 42.1215 49.8289 41.7816 49.489C41.4417 49.1491 40.9807 48.9582 40.5 48.9582Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_275_2655">
        <Rect
          width={29}
          height={29}
          fill={color}
          transform="translate(26 26)"
        />
      </ClipPath>
    </Defs>
  </Svg>
)
export default CautionIcon
